import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Drawer, Toolbar, Divider, List, IconButton, Tooltip } from '@mui/material';
import { Menu, MenuOpen, Settings as SettingsIcon } from '@mui/icons-material';
import { AUTH_LEVELS } from '../../../auth/Authorized';
import Nbsp from '../../../util/Nbsp';
import AdminMenu from './AdminMenu';
import DrawerItem from './DrawerItem';
import DrawerGroupHeader from './DrawerGroupHeader';

import './nav-drawer.css';

/* eslint-disable react/jsx-props-no-spreading */
const ACCOUNT_MENU_ITEM = {
  to: '/account',
  text: 'Account',
  icon: SettingsIcon,
};

const EMPTY_STATE_KEY = 'navDrawerOpen';

const getSavedOpenState = () => {
  try {
    const saved = localStorage.getItem(EMPTY_STATE_KEY);
    return saved === 'true';
  } catch {
    return false;
  }
};

const saveOpenState = (isOpen) => {
  try {
    localStorage.setItem(EMPTY_STATE_KEY, !!isOpen);
  } catch {
    // nothing to do here
  }
};

/**
 * Expand/shrink-able left hand navigation drawer with submenu support
 */
const NavDrawer = ({ userFullName, orgShortName, isLoggedIn, navItems }) => {
  const [open, setOpenState] = useState(getSavedOpenState());
  const setOpen = (isOpen) => {
    setOpenState(isOpen);
    saveOpenState(isOpen);
  };

  if (!isLoggedIn) return null;
  const openClass = open ? 'open' : 'closed';

  return (
    <Drawer variant="permanent" anchor="left" className={`nav nav-drawer ${openClass}`}>
      <Toolbar /> {/* offsets the fixed top toolbar */}
      <div className="drawer-container">
        <div className="user-info">
          <div>
            <span>{open ? userFullName : <Nbsp />}</span>
          </div>
          <div>
            <span>{open ? orgShortName : <Nbsp />}</span>
          </div>
        </div>
        <Divider className="user-info-divider" />

        <div className="toggle-container">
          <Tooltip tag="Tooltip" title={open ? 'Minimize menu' : 'Expand menu'}>
            <IconButton className="toggle" onClick={() => setOpen(!open)} size="large">
              {open ? <MenuOpen /> : <Menu />}
            </IconButton>
          </Tooltip>
        </div>
        <div style={{ overflowY: 'scroll', overflowX: 'hidden' }}>
          {navItems.map((group) => (
            <div key={group.text}>
              {open ? <DrawerGroupHeader text={group.text} /> : <div style={{ height: '2.1em' }} />}
              <List dense style={{ padding: 0 }}>
                {group.items.map((p) => (
                  <DrawerItem key={p.text} isOpen={open} {...p} />
                ))}
              </List>
            </div>
          ))}

          <div className="fill-with-empty" />

          <div className="admin-commands">
            {open ? <DrawerGroupHeader text="Admin" /> : <div style={{ height: '2.1em' }} />}
            <List>
              <AdminMenu isOpen={open} />
              <DrawerItem isOpen={open} {...ACCOUNT_MENU_ITEM} />
            </List>
          </div>
        </div>
        <div style={{ marginTop: 'auto', fontSize: '.6rem' }}>
          COPYRIGHT ONBOARD DATA INC. {new Date().getFullYear()}
        </div>
      </div>
    </Drawer>
  );
};

export default connect(({ user: { jwt, userAuthLevel, userFullName, orgShortName } }) => ({
  isLoggedIn: jwt != null && userAuthLevel <= AUTH_LEVELS.PORTAL_USER,
  userFullName,
  orgShortName,
}))(NavDrawer);
